import { cx } from '@libs/classnames';
import { CameraIcon } from '@ui/icons/CameraIcon';
import { MicIcon } from '@ui/icons/MicIcon';
import { OnAirIcon } from '@ui/icons/OnAirIcon';

import styles from './VideoStatusIcon.module.css';

type Props = {
  // размер и отступы задает владелец: на каждую иконку
  className?: string;
  // связь с комнатой порвалась
  error?: boolean;
  // идет трансляция с этого устройства
  live?: boolean;
  // в эфире выключены камера или микрофон: вместо значка эфира перечеркнутые иконки
  camOff?: boolean;
  micOff?: boolean;
};

// Значок состояния видеоконтроля на плашке турнира и кнопке страницы партии: нет связи,
// выключенные камера и микрофон, в эфире или просто камера. Выключенные иконки — две
// рядом без обертки: обертку (кнопку, строку) дает владелец
export function VideoStatusIcon({ className, error, live, camOff, micOff }: Props) {
  const alert = cx(className, styles.is_alert);
  if (error) return <CameraIcon className={alert} off />;
  if (live && (camOff || micOff)) {
    return (
      <>
        {camOff && <CameraIcon className={alert} off />}
        {micOff && <MicIcon className={alert} off />}
      </>
    );
  }
  if (live) return <OnAirIcon className={alert} />;
  return <CameraIcon className={className} />;
}

// Выключенные камера или микрофон в эфире: владелец оборачивает иконки
export function isVideoOff({ error, live, camOff, micOff }: Omit<Props, 'className'>): boolean {
  return !error && !!live && (!!camOff || !!micOff);
}
